import type { OuiTagStatus } from 'omnium-ui/tag';
import type { ActeurParcoursHabilitation } from './habilitation-parcours.model';
import type { HabilitationStatut } from './types/habilitation-statut.type';

export interface HabilitationStatusPresentation {
  status: OuiTagStatus;
  buttonText: string;
}

const presentation = (
  status: OuiTagStatus,
  buttonText: string
): HabilitationStatusPresentation => ({ status, buttonText });

const DEFAULT_STATUS_PRESENTATIONS: Record<
  ActeurParcoursHabilitation,
  HabilitationStatusPresentation
> = {
  consultant: presentation('transition', 'Voir'),
  shm: presentation('transition', 'Voir'),
};

const STATUS_PRESENTATIONS: Record<
  ActeurParcoursHabilitation,
  Partial<Record<HabilitationStatut, HabilitationStatusPresentation>>
> = {
  consultant: {
    pret: presentation('todo', 'Compléter'),
    a_affecter: presentation('transition', 'Voir'),
    a_controler: presentation('transition', 'Voir'),
    validation_en_cours: presentation('transition', 'Voir'),
    controle_en_cours: presentation('transition', 'Voir'),
    nc_traitee: presentation('transition', 'Voir'),
    nc_a_traiter: presentation('error', 'Corriger'),
    valide: presentation('completed', 'Voir'),
    expire: presentation('error', 'Expiré'),
    refuse: presentation('error', 'Voir'),
    annule: presentation('pending', 'Démarrer'),
    verrouille: presentation('pending', 'Verrouillé'),
    action_consultant: presentation('todo', 'Compléter'),
    action_backoffice: presentation('transition', 'Voir'),
    attente_service_externe: presentation('transition', 'Voir'),
  },
  shm: {
    pret: presentation('transition', 'Voir'),
    a_affecter: presentation('todo', 'Compléter'),
    a_controler: presentation('todo', 'Compléter'),
    validation_en_cours: presentation('transition', 'Voir'),
    controle_en_cours: presentation('transition', 'Voir'),
    nc_traitee: presentation('transition', 'Voir'),
    nc_a_traiter: presentation('todo', 'Compléter'),
    valide: presentation('completed', 'Voir'),
    expire: presentation('error', 'Voir'),
    refuse: presentation('error', 'Voir'),
    annule: presentation('pending', 'Voir'),
    verrouille: presentation('pending', 'Verrouillé'),
    action_consultant: presentation('transition', 'Voir'),
    action_backoffice: presentation('todo', 'Compléter'),
    attente_service_externe: presentation('transition', 'Voir'),
  },
};

export function getHabilitationStatusPresentation(
  actor: ActeurParcoursHabilitation,
  statut?: HabilitationStatut | string
): HabilitationStatusPresentation {
  return (
    (statut ? STATUS_PRESENTATIONS[actor][statut as HabilitationStatut] : undefined) ??
    DEFAULT_STATUS_PRESENTATIONS[actor]
  );
}
